import { FC } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { QuestionPageContainer } from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { conditionalPhone } from "~/utils/validations";
import { PhoneForm, DuplicatePhone } from "./components";
import { formatPhone } from "./utils";

export type Values = {
  phone: string;
  international: boolean;
};

const validationSchema = Yup.object({
  phone: conditionalPhone,
  international: Yup.boolean(),
});

export const PhonePage: FC = () => {
  const { international, phone } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  const initialValues: Values = {
    phone: phone ? formatPhone({ value: phone, oldValue: "" }) : "",
    international: international || false,
  };

  const formik = useFormik({
    initialValues,
    onSubmit: onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  if (formik.errors.phone == "Phone number not available.") {
    return (
      <QuestionPageContainer>
        <DuplicatePhone />
      </QuestionPageContainer>
    );
  }

  return (
    <QuestionPageContainer>
      <PhoneForm formik={formik} />
    </QuestionPageContainer>
  );
};
